var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('v-autocomplete',{attrs:{"item-text":_vm.itemText,"item-value":_vm.itemValue,"items":_vm.list,"v-model":_vm.selected,"label":_vm.label}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }